import { ProductOrientation } from "../models/layout/product-orientation";

export class UpdateMerchDefaultOrientationsRequest{
    merchId : number = -1;
    productOrientations : Object;
    constructor(merchId: number, productOrientations: Map<number, number>){
        this.merchId = merchId;
        this.productOrientations = Object.fromEntries(productOrientations);
    }
}